// The product name shown to users everywhere (docs/contract.md section 8).
// "ProcureAI" stays only as the code and repository name.
export const PRODUCT_NAME = "Public Procurement Tools (Pluto)";
/** The one-line wordmark beside the mark in the sidebar; the full name stays in <title> and on the sign-in pages. */
export const PRODUCT_SHORT = "Pluto";
